import React from "react";
import ServicePageTemplate from "../../components/ServicePageTemplate";
import { Sparkles } from "lucide-react";

const JoyRides = () => {
  const serviceData = {
    serviceName: "Joy Rides",
    heroImage: require("../../assets/krk_hangar_jakkur.jpeg"),
    heroTagline: "Experience the Thrill of Flying",
    heroDescription:
      "Soar above Bangalore and witness the city from breathtaking heights. Our helicopter joy rides offer an unforgettable adventure for adventurers, families, and celebration seekers.",
    overviewTitle: "Helicopter Joy Rides in Bangalore",
    overviewText: `HighKraft Aviation brings the magic of flight to everyone with our exhilarating helicopter joy rides over Bangalore. Experience the thrill of taking off, the wonder of seeing familiar landmarks from above, and the pure joy of flight in our modern, comfortable helicopters.

Our joy rides are perfect for anyone seeking a unique adventure – from first-time flyers experiencing the excitement of helicopter travel to aviation enthusiasts who never tire of being airborne. See Bangalore's stunning skyline, beautiful lakes, green parks, and iconic landmarks from a perspective few ever experience.

Whether you're planning a special birthday surprise, a romantic experience, a family adventure, or simply checking an item off your bucket list, our joy rides create memories that last a lifetime. With multiple duration options available, there's a perfect flight for every preference and budget.`,
    useCases: [
      {
        title: "Birthday Celebrations",
        description:
          "Make birthdays extraordinary with a helicopter ride the birthday star will never forget.",
      },
      {
        title: "Anniversary Surprises",
        description:
          "Celebrate your love with a romantic flight over the city for two.",
      },
      {
        title: "Family Adventures",
        description:
          "Create lasting family memories with a shared helicopter experience.",
      },
      {
        title: "Romantic Proposals",
        description:
          "Pop the question with the city sparkling below – a magical moment guaranteed.",
      },
      {
        title: "Tourist Experiences",
        description:
          "See Bangalore from a unique perspective during your city visit.",
      },
      {
        title: "Corporate Rewards",
        description:
          "Reward top performers with an exciting helicopter experience.",
      },
    ],
    safetyFeatures: [
      {
        title: "DGCA Certified Operations",
        description:
          "All joy rides operated under strict DGCA guidelines and certifications.",
      },
      {
        title: "Experienced Joy Ride Pilots",
        description:
          "Friendly pilots who make your first flight comfortable and memorable.",
      },
      {
        title: "Safety Briefings",
        description:
          "Comprehensive pre-flight briefings covering all safety procedures.",
      },
      {
        title: "Modern Fleet",
        description:
          "Well-maintained helicopters with the latest safety features.",
      },
      {
        title: "Weather Flexibility",
        description:
          "Free rescheduling if weather conditions are not suitable for safe flying.",
      },
      {
        title: "Insurance Coverage",
        description:
          "All passengers covered by comprehensive flight insurance.",
      },
    ],
    galleryImages: [
      require("../../assets/joyride_jakkur_1.jpeg"),
      require("../../assets/joyride_jakkur_2.jpeg"),
      require("../../assets/joyride_jakkur_3.jpeg"),
    ],
    faqs: [
      {
        question: "What is the duration of joy ride flights?",
        answer:
          "We offer multiple duration options: 10-minute quick flights, 15-minute landmark tours, and 30-minute extended experiences. Choose based on your preference and budget.",
      },
      {
        question: "How many people can fly together?",
        answer:
          "Our helicopters accommodate 2-4 passengers per flight depending on the model. Larger groups can be accommodated with consecutive flights.",
      },
      {
        question: "Is there an age limit for joy rides?",
        answer:
          "Children above 3 years are welcome when accompanied by an adult. There is no upper age limit – we welcome adventure seekers of all ages!",
      },
      {
        question: "Can I take photos and videos during the flight?",
        answer:
          "Absolutely! We encourage capturing the experience. Bring your camera, phone, or GoPro. Our pilots can point out the best photo opportunities.",
      },
      {
        question: "What landmarks will we see during the flight?",
        answer:
          "Routes typically cover Cubbon Park, Vidhana Soudha, Ulsoor Lake, the IT corridor, and other iconic Bangalore landmarks. The exact route may vary based on air traffic.",
      },
      {
        question: "How do I book a joy ride?",
        answer:
          "Book via WhatsApp, phone call, or through our website contact form. We recommend booking 3-5 days in advance, especially for weekends.",
      },
    ],
    icon: Sparkles,
  };

  return <ServicePageTemplate {...serviceData} />;
};

export default JoyRides;
